// extracted by mini-css-extract-plugin
export default {"addressAction":"o3-z","loading":"p3-z"};